document.addEventListener("DOMContentLoaded", () => {
  // section-showcase-image 模块超出50个block设置范围(将其它模块内容插入到第一个模块中)
  function blockdeal() {
    const sections = document.querySelectorAll(".section-showcase-image1");
    if (sections.length <= 1) return;

    const firstSection = sections[0];
    const firstImageList = firstSection.querySelector(".image_list");
    const firstDialogWrapper = firstSection.querySelector(".product_dialog .swiper-wrapper");

    function processElements(selector, target, removeParent = false) {
      sections.forEach((section, index) => {
        if (index === 0) return;

        const elements = section.querySelectorAll(selector);
        elements.forEach((element) => {
          target.appendChild(element);
        });

        if (removeParent) {
          section.remove();
        }
      });
    }

    // 处理image_list部分
    processElements(".section-showcase-image1 .image_item", firstImageList);

    // 处理product_dialog部分(弹窗)
    processElements(".section-showcase-image1 .product_item", firstDialogWrapper, true);


    // 更改 video 的 id 名
    const videoList = document.querySelectorAll('.section-showcase-image1 .product_item')
    videoList.forEach(function(section, index) {
      var itemVideo = section.querySelector('video')
      if (itemVideo) {
        itemVideo.setAttribute('id', `video-${index + 1}`);
      }
      
    })
  }

  blockdeal();


  
  // 暂停所有视频播放
  function pauseVideo() {
    let child_length = $(".section-showcase-image1 .image_list .image_item").length;
    for (let i = 1; i <= child_length; i++) {
      let videoEl = document.querySelector(`.section-showcase-image1 #video-${i}`);
      try {
        videoEl.pause();
      } catch (error) {}
    }
  }

  var mySwiper = new Swiper(".section-showcase-image1 .swiper_product", {
    slidesPerView: 1,
    spaceBetween: 20,
    effect: "fade",
    autoHeight: true,
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".section-showcase-image1 .button_next",
      prevEl: ".section-showcase-image1 .button_prev",
    },

    // 防止一开始弹窗为none时swiper切换无效
    observer: true,
    observeParents: true,
    on: {
      slideChangeTransitionEnd: function () {
        pauseVideo();
        try {
          console.log(this.activeIndex, "===");
          document.querySelector(`.section-showcase-image1 #video-${this.activeIndex + 1}`).play();
        } catch (error) {}
      },
    },
  });

  // 产品点击事件
  let scrollTop = "";
  $(".section-showcase-image1 .image_list .image_item").click(function () {
    let index = $(".section-showcase-image1 .image_list .image_item").index(this);
    mySwiper.slideTo(index, 0);
    $(".section-showcase-image1 .product_dialog").css("display", "block");
    scrollTop = $(window).scrollTop();
    $("body").css("top", 0 - scrollTop);
    let videoEl = document.querySelector(`.section-showcase-image1 #video-${index + 1}`);
    if (!videoEl) return;
    let source = videoEl.querySelector("source");
    if (!source) return;
    source.src = source.getAttribute("data-src");
    videoEl.load();
    videoEl.play();
  });

  // 关闭弹窗
  $(".section-showcase-image1 .product_dialog .close_dialog,.section-showcase-image1 .product_dialog .daialo-bg").click(
    function () {
      pauseVideo();
      $(".section-showcase-image1 .product_dialog").css("display", "none");
      $("body").removeClass("noscroll");
      $(window).scrollTop(scrollTop);
    }
  );

  $(document).on("keydown", function (event) {
    if (event.key === "Escape") {
      event.preventDefault();
      event.stopPropagation();
      $(".section-showcase-image1 .product_dialog").css("display", "none");
      $("body").removeClass("noscroll");
      $(window).scrollTop(scrollTop);
    }
  });

  // show_more buttom
    let number = $(".section-showcase-image1 .show_more").data("only");
  $(".section-showcase-image1 .show_more").click(function () {
    number += number;
    console.log(number);
    for (let i = 0; i < number; i++) {
      $(".section-showcase-image1 .image_list .image_item").eq(i).show();
      $(".section-showcase-image1 .swiper-wrapper .product_item").eq(i).css("display", "flex");
    }
    mySwiper.update(true);
    if ($(".section-showcase-image1 .image_list .image_item").last().css("display") == "block") {
      $(".section-showcase-image1 .show_more").hide();
    }
  });
  
});
